"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableBordersBase = void 0;
var math_1 = require("@devexpress/utils/lib/utils/math");
var TableBordersBase = (function () {
    function TableBordersBase() {
    }
    TableBordersBase.prototype.getHashCode = function () {
        return math_1.MathUtils.somePrimes[10] * this.topBorder.getHashCode() ^
            math_1.MathUtils.somePrimes[11] * this.rightBorder.getHashCode() ^
            math_1.MathUtils.somePrimes[12] * this.bottomBorder.getHashCode() ^
            math_1.MathUtils.somePrimes[13] * this.leftBorder.getHashCode();
    };
    TableBordersBase.prototype.equals = function (obj) {
        if (!obj)
            return false;
        return this.bottomBorder.equals(obj.bottomBorder) &&
            this.leftBorder.equals(obj.leftBorder) &&
            this.rightBorder.equals(obj.rightBorder) &&
            this.topBorder.equals(obj.topBorder);
    };
    TableBordersBase.prototype.copyFrom = function (obj) {
        this.bottomBorder = obj.bottomBorder.clone();
        this.leftBorder = obj.leftBorder.clone();
        this.rightBorder = obj.rightBorder.clone();
        this.topBorder = obj.topBorder.clone();
    };
    return TableBordersBase;
}());
exports.TableBordersBase = TableBordersBase;
